<template>
	<div class="container" id="biotesting_quiz_section">
		<div class="row text-center">
			<h4 class="col gold">
				<span v-text="this.$route.meta.title"></span>
			</h4>
		</div>

		<div class="row">
			<div class="col text-left">
				<BioTestingButtons title='<i class="fas fa-home"></i> Admin Quiz Actions' />
			</div>
		</div>

		<div v-if="show_quiz_list == 1" class="row">
			<div v-if="list_of_quizzes.length > 0" class="col-12">
				<b-list-group v-for="(Q, key) in list_of_quizzes" :key="Q.pkid">
					<b-list-group-item :variant="list_status[Q.status].class">
						<div class="row">
							<div class="col-8">
								Status: <span v-text="list_status[Q.status].text"></span><br />
								<b v-text="Q.title"></b>
								<p v-text="Q.description"></p>
							</div>

							<div class="col-4 text-right">
								<b-dropdown right text="Actions" class="m-md-2">
									<b-dropdown-item>
										<b-button variant="outline-secondary" @click="goTo('edit', Q.pkid)">
											<i class="fas fa-pencil-alt"></i> Edit
										</b-button>
									</b-dropdown-item>

									<b-dropdown-item>
										<b-button variant="outline-primary" @click="goTo('take', Q.pkid)">
											<i class="fas fa-thumbs-up"></i> View / Sample Quiz
										</b-button>
									</b-dropdown-item>

									<b-dropdown-divider></b-dropdown-divider>

									<b-dropdown-item>
										<b>Set Status</b><br />
										<b-button-group>
											<b-button variant="outline-success" @click="setQuizStatus(Q, 1)">
												<i class="fas fa-check"></i> Active
											</b-button>
											<b-button variant="outline-secondary" @click="setQuizStatus(Q, 2)">
												<i class="fas fa-pause"></i> Draft
											</b-button>
											<b-button
												variant="outline-danger"
												@click="
													confirmDelete(
														'Are you sure you want to completly remove this quiz?',
														Q,
														key
													)
												"
											>
												<i class="fas fa-times"></i> Delete
											</b-button>
										</b-button-group>
									</b-dropdown-item>
								</b-dropdown>
							</div>
						</div>
					</b-list-group-item>
				</b-list-group>
			</div>

			<div v-else class="col-12 mt-5 gold">
				<div class="text-center">
					<i class="fas fa-spinner fa-spin fa-2x"></i>
					<p>Loading Quiz data...</p>
				</div>
			</div>
		</div>

		<div v-else>
			<div class="row mb-3">
				<div class="col-md-2 text-right">
					<label for="input-invalid">Name of Quiz:</label>
				</div>
				<div class="col-md-6">
					<b-form-input
						v-model="title"
						:state="titleState"
						placeholder="Enter a title for this quiz"
					></b-form-input>
				</div>
			</div>
			<div class="row mb-3">
				<div class="col-md-2 text-right">
					<label for="input-invalid">Description:</label>
				</div>
				<div class="col-md-10">
					<b-form-input
						v-model="description"
						:state="descriptionState"
						placeholder="This will let the user know what this quiz is testing for (min 10chars)"
					></b-form-input>
				</div>
			</div>

			<div class="row mb-3">
				<div class="col-md-2 text-right">
					<label for="input-invalid">Help text:</label>
				</div>
				<div class="col-md-10">
					<b-form-textarea
						v-model="help_text"
						rows="3"
						max-rows="6"
						placeholder="Add any help text. Show to users at the top of the quiz."
					></b-form-textarea>
				</div>
			</div>

			<draggable
				tag="ul"
				class="list-group"
				v-model="questions"
				v-bind="dragOptions"
				@start="dragging = true"
				@end="dragging = false"
				handle=".handle"
			>
				<li
					class="list-group-item question_row"
					:class="item.class"
					v-for="(item, key) in questions"
					:key="item.id"
				>
					<div class="row">
						<div class="col-1 handle move">
							<span class="fa-stack fa-1x" v-b-tooltip.hover title="Re-order question">
								<i class="fas fa-long-arrow-alt-up"></i>
								<i class="fas fa-long-arrow-alt-down"></i>
							</span>
							<!--small class="ml-1" v-text="item.id"></small>-->
						</div>

						<div v-if="item.type == 'section'" class="col-10">
							<b-form-input
								v-model="item.question"
								placeholder="Section title..."
								@keyup="validateItem(item, 0)"
							></b-form-input>
						</div>

						<div v-else class="col-10">
							<div class="row">
								<div class="col-md-6">
									<b-form-input
										v-model="item.question"
										placeholder="Question..."
										@keyup="validateItem(item, 0)"
									></b-form-input>
								</div>
								<div class="col-md-6">
									<b-form-input
										v-model="item.help_text"
										placeholder="Help text..."
										@keyup="validateItem(item, 0)"
									></b-form-input>
								</div>
							</div>

							<div class="row mt-1">
								<div class="col-md-6">
									<b-form-select
										v-model="item.type"
										:options="options_type"
										@change="validateItem(item, 0)"
									></b-form-select>
								</div>
								<div class="col-md-6">
									<div v-if="item.type == 'yesNo'" class="row ml-0 mr-0">
										<b-form-input
											class="col-4"
											v-model="item.answer_values[0]"
											placeholder="Yes value"
											type="number"
											@keyup="validateItem(item, 0)"
										></b-form-input>
									</div>
									<div v-if="item.type == 'severity'" class="row ml-0 mr-0">
										<b-form-input
											class="col"
											v-model="item.answer_values[0]"
											placeholder="val Mild"
											type="number"
											@keyup="validateItem(item, 0)"
										></b-form-input>
										<b-form-input
											class="col"
											v-model="item.answer_values[1]"
											placeholder="val Moderate"
											type="number"
											@keyup="validateItem(item, 0)"
										></b-form-input>
										<b-form-input
											class="col"
											v-model="item.answer_values[2]"
											placeholder="val Servere"
											type="number"
											@keyup="validateItem(item, 0)"
										></b-form-input>
									</div>
								</div>
							</div>
						</div>

						<div class="col-1 text-right">
							<i
								class="fas fa-times text-danger pointer"
								@click="removeAt(key, item.pkid)"
								v-b-tooltip.hover
								title="Click to remove"
							></i>
						</div>
					</div>
				</li>

				<div v-if="titleState == true" class="row mt-2" slot="footer">
					<div class="col-6 text-left">
						<button @click="addSection" class="btn btn-sm btn-outline-secondary">
							<i class="fas fa-plus"></i> Add Section
						</button>
						<button
							v-if="questions.length > 0"
							@click="addQuestion"
							class="btn btn-sm btn-outline-primary"
						>
							<i class="fas fa-plus"></i> Add Question
						</button>
					</div>

					<div v-if="questions.length > 0" class="col-12 text-center">
						<b-alert v-if="titleState == false" show variant="danger">
							You need to give this quiz a name (top of page) before you can save
						</b-alert>

						<div v-else>
							<button @click="update" class="btn btn-block btn-success">
								<i class="far fa-save"></i> Save / Update
							</button>
							<p class="text-danger" v-text="error.update"></p>
						</div>
					</div>
				</div>

				<div v-if="processing == 1" class="row">
					<div class="col-12 text-center mt-5 gold">
						<i class="fas fa-spinner fa-spin fa-3x"></i>
						<p>Processing...</p>
					</div>
				</div>
			</draggable>

			<div class="card m-4">
				<div class="card-body">
					<h5>Help & Tips...</h5>
					<ol>
						<li>Enter a name & description for the quiz...</li>
						<li>
							<b>Sections</b>
							<ul>
								<li>the Quiz must start with a Section title</li>
								<li>
									Separate questions into sections - this will help readability to the user
									filling out the quiz...
								</li>
							</ul>
						</li>
						<li>
							<b>Questions</b>
							<ul>
								<li>Enter the question</li>
								<li>Help text is optional</li>
								<li>
									Select answer type and value fields will appear where you input the value
									for the selected option
								</li>
							</ul>
						</li>
						<li>
							Questions & Sections will have an highlighted background until you have entered
							all required inputs
						</li>
						<li>You can reorder Questions & Sections by drag and drop</li>
						<li>
							When you have completed adding Questions & Sections and you have saved the
							quiz, click the<br />
							Quiz dashboard button at the top to access more options for the quiz
						</li>
					</ol>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
/* https://sortablejs.github.io/Vue.Draggable */
import draggable from 'vuedraggable';
import axios from 'axios';

import BioTestingButtons from '../components/BioTestingButtons.vue';

export default {
	name: 'BioTesting',
	components: {
		BioTestingButtons,
		draggable,
	},
	props: {},
	data() {
		return {
			dragging: false,

			error: { update: '' },

			list_of_quizzes: [],

			show_quiz_list: 1,

			title: '',
			description: '',
			help_text: '',

			options_type: [
				{ value: '', text: 'Select answer type' },
				{ value: 'severity', text: 'Mild, Moderate, Servere' },
				{ value: 'yesNo', text: 'Yes | No' },
			],

			processing: 0,
			qid: 0,

			questionnaire_id: 0,
			questions: [],

			showUpdate: 0,
		};
	},
	methods: {
		addQuestion() {
			var item = {
				id: this.qid++,
				pkid: 0,
				question: '',
				help_text: '',
				type: '',
				answer_values: [],
				class: 'list-group-item-warning',
			};
			this.questions.push(item);
			this.validateItem(item, 1);
		},

		addSection() {
			var item = {
				id: this.qid++,
				pkid: 0,
				type: 'section',
				class: 'list-group-item-warning',
			};
			this.questions.push(item);
		},

		confirmDelete(message, item, key) {
			this.$bvModal
				.msgBoxConfirm(message, {
					title: 'Confirm delete',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'danger',
					okTitle: 'Yes - delete',
					cancelTitle: 'Cancel',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true,
				})
				.then((value) => {
					if (value == true) {
						item.key = key;
						this.setQuizStatus(item, 0);
					}
				})
				.catch((err) => {
					console.log('confirmDelete:' + err);
				});
		},

		goTo(path, id) {
			var link = '/bioTesting/';
			if (path == 'edit') {
				link += 'quizzes/edit/' + id;
				this.show_quiz_list = 0;
				this.processing = 1;
				this.questionnaire_id = id;
				this.questionnaireLoad(this.questionnaire_id);
			} else if (path == 'take') {
				link += 'takeQuiz/' + id;
			}
			this.$router.push(link);
		},

		questionnaireLoad(questionnaire_id) {
			let _this = this;

			_this.error.update = '';

			let params = new URLSearchParams();
			params.append('token', _this.$store.state.session_id);
			params.append('questionnaire_id', questionnaire_id);

			axios({
				url: _this.$store.state.api_url + 'bio_questionnaire_load',
				params: params,
			})
				.then(function (response) {
					if (response.data.status == 1) {
						_this.questions = response.data.questions;
						_this.title = response.data.title;
						_this.description = response.data.description;
						_this.help_text = response.data.help_text;
						_this.processing = 0;
						_this.qid = _this.questions.length;
					}
				})
				.catch(function (e) {
					console.log('Error: questionnaireLoad:' + e);
				});
		},

		questionnaireList() {
			let _this = this;

			_this.error.update = '';

			let params = new URLSearchParams();
			params.append('token', _this.$store.state.session_id);

			axios({
				url: _this.$store.state.api_url + 'bio_questionnaire_list',
				params: params,
			})
				.then(function (response) {
					if (response.data.status == 1) {
						_this.list_of_quizzes = response.data.list;
					}
				})
				.catch(function (e) {
					console.log('Error: bio_questionnaire_list:' + e);
				});
		},

		removeAt(key, pkid) {
			let _this = this;

			this.questions.splice(key, 1);

			if (pkid > 0) {
				let params = new URLSearchParams();
				params.append('token', _this.$store.state.session_id);
				params.append('pkid', pkid);

				axios({
					url: _this.$store.state.api_url + 'bio_questionnaire_delete_question',
					params: params,
				})
					.then(function (response) {
						console.log('Question removed:' + response.data.status);
					})
					.catch(function (e) {
						console.log('Error: bio_questionnaire_set_status:' + e);
					});
			}
		},

		setQuizStatus(item, status) {
			let _this = this;

			_this.error.update = '';

			let params = new URLSearchParams();
			params.append('token', _this.$store.state.session_id);
			params.append('status', status);
			params.append('questionnaire_id', item.pkid);

			axios({
				url: _this.$store.state.api_url + 'bio_questionnaire_set_status',
				params: params,
			})
				.then(function (response) {
					item.status = response.data.status;
					if (item.status == 0) {
						_this.list_of_quizzes.splice(item.key, 1);
					}
				})
				.catch(function (e) {
					console.log('Error: bio_questionnaire_set_status:' + e);
				});
		},

		update() {
			console.log('update');
			let _this = this;

			_this.processing = 1;
			_this.error.update = '';

			let params = new URLSearchParams();
			params.append('token', _this.$store.state.session_id);
			params.append('title', _this.title);
			params.append('description', _this.description);
			params.append('help_text', _this.help_text);
			params.append('questionnaire_id', _this.questionnaire_id);
			params.append('questions', JSON.stringify(_this.questions));

			axios
				.post(_this.$store.state.api_url + 'bio_questions_save', params)
				.then(function (response) {
					_this.processing = 0;
					_this.error.update = response.data.message;

					if (response.data.status == 1) {
						if (_this.questionnaire_id == 0) {
							_this.questionnaire_id = response.data.questionnaire_id;
							_this.$router.push(
								'/bioTesting/quizzes/edit/' + response.data.questionnaire_id
							);
						} else {
							_this.questionnaire_id = response.data.questionnaire_id;
							_this.$router.go();
						}
					}
				})
				.catch(function (e) {
					console.log('Error: update:' + e);
				});

			/*axios({
				url: _this.$store.state.api_url + 'bio_questions_save',
				params: params,
			})
				.then(function (response) {
					_this.processing = 0;
					_this.error.update = response.data.message;

					if (response.data.status == 1) {
						if (_this.questionnaire_id == 0) {
							_this.questionnaire_id = response.data.questionnaire_id;
							_this.$router.push(
								'/bioTesting/quizzes/edit/' + response.data.questionnaire_id
							);
						} else {
							_this.questionnaire_id = response.data.questionnaire_id;
							_this.$router.go();
						}
					}

				})
				.catch(function (e) {
					console.log('Error: update:' + e);
				});*/
		},

		validateItem(item, force) {
			var isValiditemIsValid = 1;

			if (force == 1) {
				isValiditemIsValid = 0;
			} else {
				if (item.type == 'section') {
					if (item.question == '') {
						isValiditemIsValid = 0;
					}
				} else if (item.question == '') {
					isValiditemIsValid = 0;
				} else if (item.type == '') {
					isValiditemIsValid = 0;
				} else if (item.answer_values.length > 0) {
					item.answer_values.forEach((elm) => {
						if (elm == '') {
							isValiditemIsValid = 0;
						}
					});
				}
			}

			if (isValiditemIsValid == 0) {
				item.class = 'list-group-item-warning';
			} else {
				if (item.type == 'section') {
					item.class = 'list-group-item-secondary';
				} else {
					item.class = '';
				}
			}
		},
	},
	computed: {
		dragOptions() {
			return {
				animation: 200,
				group: 'description',
				disabled: false,
				ghostClass: 'ghost',
			};
		},
		list_status() {
			const list = [];
			list[0] = {
				text: 'Closed',
				class: 'danger',
			};
			list[1] = {
				text: 'Active',
				class: 'success',
			};
			list[2] = {
				text: 'Draft',
				class: 'secondary',
			};
			return list;
		},
		descriptionState() {
			return this.description.length >= 10 ? true : false;
		},
		titleState() {
			return this.title.length > 2 ? true : false;
		},
	},
	created() {},
	mounted() {
		if (this.$route.params.quiz_id) {
			this.processing = 1;
			this.questionnaire_id = this.$route.params.quiz_id;
			this.questionnaireLoad(this.questionnaire_id);
		} else if (this.$route.name == 'bioTestingCreateQuiz') {
			this.show_quiz_list = 0;
		}

		this.questionnaireList();
	},
	watch: {
		questionnaire_id(val) {
			if (val > 0) {
				this.show_quiz_list = 0;
			}
		},
	},
};
</script>
<style>
.list-group-item-secondary {
	background-color: #f7f7f7 !important;
}

.move {
	cursor: move;
}
.pointer {
	cursor: pointer;
}

.flip-list-move {
	transition: transform 0.5s;
}
.no-move {
	transition: transform 0s;
}
.ghost {
	opacity: 0.8;
	background-color: #d1af60 !important;
}
</style>
